import { useTranslation } from '@crehana/i18n';

import type { TasksLocaleKeys } from '../types';

const useTasksTranslations = () => useTranslation<TasksLocaleKeys>();

export default useTasksTranslations;
